import { useSelector } from 'react-redux';
import { RootState } from '@center-pwa/store/store';

/**
 * Hook to check which event types have active subscribers in the metaspace
 * @param eventType - Optional specific event type to check (e.g., 'CHAT_TRIGGERED')
 * @returns Subscriber information for the specified event type or all event types
 *
 * @example
 * // Check if there are any subscribers for CHAT_TRIGGERED event
 * const { hasSubscribers } = useEventSubscribers('CHAT_TRIGGERED');
 * if (hasSubscribers) {
 *   // Show chat icon
 * }
 *
 * @example
 * // Get all subscribers for all event types
 * const { allSubscribers } = useEventSubscribers();
 * console.log('All subscribers:', allSubscribers);
 */
export const useEventSubscribers = (eventType?: string) => {
  const subscribers = useSelector(
    (state: RootState) => state.metaspaceEvents.subscribers
  );

  if (eventType) {
    return {
      hasSubscribers: subscribers[eventType]?.length > 0,
      count: subscribers[eventType]?.length || 0,
      subscriberIds: subscribers[eventType] || []
    };
  }

  return { allSubscribers: subscribers };
};
